var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./address.svg": "./src/icons/svg/address.svg",
	"./arrow_down.svg": "./src/icons/svg/arrow_down.svg",
	"./arrow_right.svg": "./src/icons/svg/arrow_right.svg",
	"./back.svg": "./src/icons/svg/back.svg",
	"./date.svg": "./src/icons/svg/date.svg",
	"./detail_address.svg": "./src/icons/svg/detail_address.svg",
	"./go_top.svg": "./src/icons/svg/go_top.svg",
	"./lecture.svg": "./src/icons/svg/lecture.svg",
	"./right_arrow.svg": "./src/icons/svg/right_arrow.svg",
	"./user.svg": "./src/icons/svg/user.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";